exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".InterTitle {\n  opacity: 0;\n  pointer-events: none;\n  -webkit-transition: opacity 1s;\n  -o-transition: opacity 1s;\n  transition: opacity 1s;\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  color: #fff;\n  text-align: center;\n  cursor: default;\n  z-index: 1000; }\n  .InterTitle img {\n    margin-bottom: 50px; }\n  .InterTitle .Text {\n    color: #fff; }\n  .InterTitle-Title {\n    font-size: 2.1rem;\n    font-weight: bold;\n    margin-bottom: 0; }\n  .InterTitle-Text {\n    font-size: 1.25rem; }\n  .InterTitle.Show {\n    opacity: 1;\n    pointer-events: initial; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/InterTitle/InterTitle.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/InterTitle/InterTitle.css
// module chunks = 0